import { useState } from 'react';
import { StaffingAssignmentListMember } from 'domain/shared/staffing';
import { Button, Tooltip } from 'framework/ui/mui-builder';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ConfirmVirtualAssignmentModal from './ConfirmVirtualAssignmentModal';
import { Stack } from '@mui/material';
import { DeleteStaffingAssignmentModal } from 'domain/shared/assignment';

const AssignmentActions = ({
  assignment,
  onReload,
  projectStartDate,
}: {
  assignment: StaffingAssignmentListMember & { isVirtual?: boolean };
  onReload: () => Promise<void>;
  projectStartDate?: string;
}) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);

  return (
    <Stack direction="row" justifyContent="flex-end" spacing={1} minWidth={220} minHeight={10}>
      {assignment.isVirtual ? (
        <>
          <Button
            variant="contained"
            size="small"
            onClick={() => setConfirmOpen(true)}
            disabled={!assignment.isVirtual}
          >
            Confirm
          </Button>
          <Button variant="outlined" color="error" size="small" onClick={() => setDeleteOpen(true)}>
            Delete
          </Button>
          <ConfirmVirtualAssignmentModal
            assignment={assignment}
            isOpen={isConfirmOpen}
            onClose={() => setConfirmOpen(false)}
            onConfirmed={onReload}
            projectStartDate={projectStartDate}
          />
          <DeleteStaffingAssignmentModal
            assignmentId={String(assignment.assignmentId)}
            isOpen={isDeleteOpen}
            onClose={() => setDeleteOpen(false)}
            onCancelClick={() => setDeleteOpen(false)}
            onDeleteAfter={async () => onReload()}
          />
        </>
      ) : (
        <Tooltip title={'Confirmed assignment'}>
          <CheckCircle color={'success'} />
        </Tooltip>
      )}
    </Stack>
  );
};
export default AssignmentActions;
